import React from "react";

import { Button } from '@mui/material'

const Popup = ({setup, onClose}) => {
  // console.log('popup:', setup);

  const styleLocal = setup.style || {
    display: setup.show ? 'block' : 'none',
    backgroundColor: 'rgb(247 247 247)',
    border: '0 solid #F9F9F9',
    borderRadius: '10px',
    color: 'black',
    position: 'fixed',
    width: 'calc(80% - 30px)',
    maxWidth: '400px',
    padding: '15px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: '9999',
    boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.35)'
  }

  return (
    <div style={styleLocal}>
      <div style={{
        position:'relative', 
        minHeight:'100px',
        display: 'flex',
        flexDirection:'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{ fontSize: 'xx-large', position:'absolute', top:'-12px', right:'-8px', cursor:'pointer' }} onClick={ () => onClose?.('cancel') }>&times;</div>
        <div style={{ textAlign:'center', margin: '12px 0 18px' }}>
          <div style={{ fontWeight:'bold', margin: '0 0 12px 0' }}>{setup.name}</div>
          <span>{setup.message}</span>
          {setup.messageExtra && <div style={{ marginTop: 10, marginBottom: 4 }}>{setup.messageExtra}</div>}
        </div>
        {Array.isArray(setup.actions) && setup.actions.length ? (
          <div id="buttonBlock" style={{ width:'100%', display: 'flex', justifyContent: 'center', gap: 8 }}>
            {setup.actions.map(action => (
              <Button
                key={action.id}
                size="small"
                variant={action.variant || 'outlined'}
                color="secondary"
                onClick={() => onClose?.(action.id)}
                sx={{
                  minWidth: 140,
                  backgroundColor: 'white',
                  color: '#BE9C74',
                  borderColor: '#BE9C74',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: '#BE9C74', color: 'white', borderColor: '#BE9C74' }
                }}
              >
                {action.label}
              </Button>
            ))}
          </div>
        ) : setup.btn ? (
          <div id="buttonBlock" style={{ width:'100%', display: 'flex', justifyContent: 'center', gap: 8 }}>
            <Button
              id='ok'
              size="small"
              variant="outlined"
              color="secondary"
              onClick={() => onClose?.('ok')}
              sx={{
                minWidth: 120,
                backgroundColor: 'white',
                color: '#BE9C74',
                borderColor: '#BE9C74',
                textTransform: 'none',
                '&:hover': { backgroundColor: '#BE9C74', color: 'white', borderColor: '#BE9C74' }
              }}
            >
              Ok
            </Button>
            <Button
              id='cancel'
              size="small"
              variant="outlined"
              color="secondary"
              onClick={() => onClose?.('cancel')}
              sx={{
                minWidth: 120,
                backgroundColor: 'white',
                color: '#BE9C74',
                borderColor: '#BE9C74',
                textTransform: 'none',
                '&:hover': { backgroundColor: '#BE9C74', color: 'white', borderColor: '#BE9C74' }
              }}
            >
              Cancel
            </Button>
          </div>
        ) : (
          <Button
            id='ok'
            size="small"
            color="secondary"
            variant="contained"
            style={{margin:'0 5px'}}
            onClick={ ()=>onClose?.('cancel') }
          >
            Ok
          </Button>
        )}
      </div>
    </div>
  )
}

export default Popup
